import React, { useEffect, useState } from "react";
import api from "../../../utils/api";
import "./Magazines.css";

const Magazines = () => {
  const [magazines, setMagazines] = useState([]);
  const [loading, setLoading] = useState(true);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [issue, setIssue] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");

  const fetchMagazines = async () => {
    try {
      const res = await api.get("/admin/magazines");
      setMagazines(res.data);
    } catch (err) {
      console.error("Failed to fetch magazines");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMagazines();
  }, []);

  const submit = async (e) => {
    e.preventDefault();

    try {
      await api.post("/admin/magazines", {
        title,
        description,
        issue,
        pdfUrl,
      });

      // reset form
      setTitle("");
      setDescription("");
      setIssue("");
      setPdfUrl("");

      fetchMagazines();
    } catch (err) {
      alert("Failed to add magazine");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete magazine?")) return;

    try {
      await api.delete(`/admin/magazines/${id}`);
      fetchMagazines();
    } catch {
      alert("Delete failed");
    }
  };

  if (loading) return <p>Loading magazines...</p>;

  return (
    <div className="magazines-container">
      <h2 className="admin-dashboard-sec-head">📚 Manage Magazines</h2>

      <p className="hint">
        📌 Upload the magazine PDF to Google Drive →  
        Set access to <b>“Anyone with the link – Viewer”</b> →  
        Paste the link below
      </p>

      {/* Add Magazine */}
      <form className="mag-form" onSubmit={submit}>
        <input
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <input
          placeholder="Issue (e.g. Jan 2025)"
          value={issue}
          onChange={(e) => setIssue(e.target.value)}
          required
        />

        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <input
          type="text"
          placeholder="Google Drive PDF link"
          value={pdfUrl}
          onChange={(e) => setPdfUrl(e.target.value)}
          required
        />

        <button type="submit">Add Magazine</button>
      </form>

      {/* List */}
      <div className="mag-grid">
        {magazines.length === 0 ? (
          <p className="empty">No magazines found</p>
        ) : (
          magazines.map((m) => (
            <div key={m._id} className="mag-card">
              <h3>{m.title}</h3>
              <p>{m.description}</p>
              <span className="issue">{m.issue}</span>

              <a
                href={m.pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="view-link"
              >
                View PDF
              </a>

              <div className="actions">
                <button className="danger" onClick={() => remove(m._id)}>
                  Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Magazines;
